import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { FootPrintApiManager_FlowService } from './FootPrintApiManager.flow.index';

import { app_validate_serial_numbersService } from './app.flow.index';

import { $types } from './app.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public FootPrintApiManager: FootPrintApiManager_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
  private _validate_serial_numbers: app_validate_serial_numbersService;
  public async validate_serial_numbers(inParams: { licenseplate: string, serialnumbers: { lookupcode: string }[], warehouseId: number }): Promise< { response?: string[] }> {
    if(!this._validate_serial_numbers) {
      this._validate_serial_numbers = this.injector.get(app_validate_serial_numbersService);
    }
    return this._validate_serial_numbers.run(inParams);
  }
}
